import React from 'react'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
// import CardMedia from '@mui/material/CardMedia'
import CssBaseline from '@mui/material/CssBaseline'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import { useNavigate } from 'react-router'

const defaultTheme = createTheme()

export function UserGroups () {
  const { myStudentGroups } = useSelector((state: State) => state.user)
  const navigate = useNavigate()

  const viewGroup = (index: number) => {
    const currentGroup = myStudentGroups[index]

    navigate('/user-groups/' + currentGroup.id)
  }

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <Container sx={{ py: 8 }} maxWidth='md'>
        <Grid container spacing={4}>
          {myStudentGroups.map((group, index) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {/* <CardMedia
                  component='div'
                  sx={{
                    pt: '56.25%'
                  }}
                  image='https://source.unsplash.com/random?wallpapers'
                /> */}
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant='h5' component='h2'>
                    {group.name}
                  </Typography>
                  {/* <Typography>
                    This is a media card. You can use this section to describe
                    the content.
                  </Typography> */}
                </CardContent>
                <CardActions>
                  <Button size='small' onClick={_ => viewGroup(index)}>
                    View
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ThemeProvider>
  )
}

export default UserGroups
